export const getOrganizationInfoFromLocalStorage = () =>
  JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );



export const checkIsModuleEnabled = (enableModuleKey) => {
  const memberSetting = JSON.parse(
    localStorage.getItem("memberSetting") !== "undefined"
      ? localStorage.getItem("memberSetting")
      : "{}"
  );
  return memberSetting?.[enableModuleKey]
}

export const checkIsMemberDirectoryEnabled = () => {
  const memberPortalDirectory = JSON.parse(
    localStorage.getItem("memberPortalDirectory") !== "undefined"
      ? localStorage.getItem("memberPortalDirectory")
      : "{}"
  );
  return memberPortalDirectory
}
  

export const getMemberSettings = () => {
  const memberSetting =  JSON.parse(
    localStorage.getItem("memberSetting") !== "undefined"
      ? localStorage.getItem("memberSetting")
      : "{}"
  );
  return memberSetting || []
}
  